type GradeFilterOption = {
    value: string;
    label: string;
}

export const GRADE_FILTER_OPTIONS: GradeFilterOption[] = [
    { value: "초1", label: "초1" },
    { value: "초2", label: "초2" },
    { value: "초3", label: "초3" },
    { value: "초4", label: "초4" },
    { value: "초5", label: "초5" },
    { value: "초6", label: "초6" },
    { value: "중1", label: "중1" },
    { value: "중2", label: "중2" },
    { value: "중3", label: "중3" },
    { value: "고1", label: "고1" },
    { value: "고2", label: "고2" },
    { value: "고3", label: "고3" },
];

// 학년 순서 정의 (초1~6, 중1~3, 고1~3)
export const GRADE_ORDER: { [key: string]: number } = {
  "초1": 1, "초2": 2, "초3": 3, "초4": 4, "초5": 5, "초6": 6,
  "중1": 7, "중2": 8, "중3": 9,
  "고1": 10, "고2": 11, "고3": 12,
};